<app-header></app-header>

<bit-container>
  <div class="bv-domain-rules-page">
    <p class="bv-domain-rules-page__desc">{{ "domainRulesDesc" | i18n }}</p>

    <div class="bv-domain-rules-page__content">
      <section class="bv-domain-rules-section">
        <div class="bv-domain-rules-section__header">
          <h2 class="bv-domain-rules-section__title">{{ "customEqDomains" | i18n }}</h2>
          <button
            type="button"
            class="bv-domain-rules-add-btn"
            (click)="openAddCustomDomainDialog()"
          >
            <span class="bv-domain-rules-add-btn__icon" aria-hidden="true"></span>
            {{ (btnTextAddCreateFeatureFlag() ? "addCustomDomain" : "newCustomDomain") | i18n }}
          </button>
        </div>

        <p class="bv-domain-rules-section__desc">{{ "newCustomDomainDesc" | i18n }}</p>
      </section>

      <section class="bv-domain-rules-section">
        <h2 class="bv-domain-rules-section__title">{{ "globalEqDomains" | i18n }}</h2>

        @if (loading) {
          <p class="bv-domain-rules-loading">
            <i
              class="bwi bwi-spinner bwi-spin"
              title="{{ 'loading' | i18n }}"
              aria-hidden="true"
            ></i>
            <span>{{ "loading" | i18n }}</span>
          </p>
        } @else if (global.length > 0) {
          <ul class="bv-domain-rules-list">
            @for (d of global; track d.key) {
              <li class="bv-domain-rules-list__item">
                <span class="bv-domain-rules-list__domains">{{ d.domains }}</span>
                <span
                  class="bv-domain-rules-list__badge"
                  [class.bv-domain-rules-list__badge--excluded]="d.excluded"
                  [class.bv-domain-rules-list__badge--included]="!d.excluded"
                >
                  {{
                    (d.excluded ? "domainRulesStatusExcluded" : "domainRulesStatusIncluded") | i18n
                  }}
                </span>
                <button
                  type="button"
                  bitIconButton="bwi-ellipsis-v"
                  class="bv-domain-rules-list__menu-btn"
                  [label]="'editDomain' | i18n"
                  [bitPopoverTriggerFor]="domainRulesMenu"
                  [popoverOpen]="isMenuOpen(d.key)"
                  (popoverOpenChange)="setMenuOpen(d.key, $event)"
                  position="below-end"
                ></button>
                <bit-popover #domainRulesMenu [title]="''">
                  <div class="bv-domain-rules-menu">
                    <button
                      type="button"
                      class="bv-domain-rules-menu__toggle"
                      (click)="toggleExcluded(d)"
                    >
                      @if (d.excluded) {
                        <span
                          class="bv-domain-rules-menu__toggle-icon bv-domain-rules-menu__toggle-icon--include"
                          aria-hidden="true"
                        ></span>
                        {{ "include" | i18n }}
                      } @else {
                        <span
                          class="bv-domain-rules-menu__toggle-icon bv-domain-rules-menu__toggle-icon--exclude"
                          aria-hidden="true"
                        ></span>
                        {{ "exclude" | i18n }}
                      }
                    </button>
                    <button
                      type="button"
                      class="bv-domain-rules-menu__customize"
                      (click)="openCustomizeDialog(d)"
                    >
                      <span class="bv-domain-rules-menu__customize-icon" aria-hidden="true"></span>
                      {{ "customize" | i18n }}
                    </button>
                  </div>
                </bit-popover>
              </li>
            }
          </ul>
        }
      </section>
    </div>
  </div>
</bit-container>
